import { createContext } from "react";
import type { Locale } from "./locale";
import type { UiKey } from "./ui";

export type I18nContextValue = {
  locale: Locale;
  setLocale: (l: Locale) => void;
  t: (key: UiKey) => string;
  tf: (key: UiKey, vars: Record<string, string | number>) => string;
};

export const I18nContext = createContext<I18nContextValue | null>(null);
